export default __webpack_public_path__ + "static/media/tumble-dryer.a946b109.svg";